{
  "fr": {
    "folders": {
      "breadcrumb": {
        "contentCount": "{count} contenu | {count} contenus",
        "overview": "Aperçu",
        "showPath": "Afficher le chemin du dossier",
        "up": "Un niveau au-dessus"
      },
      "buttons": {
        "back": "Retour",
        "clearDiscarded": "Vider la corbeille",
        "createFolder": "Créer un dossier",
        "deleteFolder": "Déplacer vers la corbeille",
        "moveFolder": "Déplacer le dossier",
        "renameFolder": "Renommer le dossier",
        "renameItem": "Renommer"
      },
      "emptyTrashDialog": {
        "button": "Vider",
        "text": "Cette action est irréversible. Tout le contenu de la corbeille sera définitivement supprimé.",
        "title": "Vider définitivement la corbeille ?"
      },
      "confirmDeleteDialog": {
        "button": "Oui, supprimer",
        "text": "Les contenus supprimés ne peuvent pas être restaurés.",
        "title": "Supprimer définitivement les contenus"
      },
      "discarded": {
        "alert": {
          "text": "Du tableau d'affichage à l'enregistrement audio - lorsque vous supprimez des matériaux, ils atterrissent ici dans la corbeille et seront <strong>supprimés définitivement après 30 jours</strong>."
        },
        "hints": {
          "noItems": {
            "emptyTable": "Il n'y a actuellement aucun contenu dans votre corbeille."
          }
        },
        "subline": "Les matériels et dossiers supprimés restent dans la corbeille pendant <strong>30 jours</strong>. Jusqu'à cette date, vous pouvez les restaurer, après quoi ils seront définitivement supprimés."
      },
      "headings": {
        "discarded": "Corbeille",
        "search": "Rechercher dans votre espace de stockage",
        "searchResults": "{count} résultats de recherche"
      },
      "hints": {
        "emptySubfolder": {
          "emptyTable": "Il n'y a actuellement aucun contenu dans ce dossier.",
          "text": "Vous pouvez facilement déplacer des contenus d'autres dossiers vers ce dossier ou créer de nouveaux contenus et sous-dossiers directement ici.",
          "title": "Ce dossier est vide"
        },
        "noItems": {
          "addContent": "Créer un nouveau contenu",
          "emptyTable": "Il n'y a pas encore de contenu dans votre espace de stockage.",
          "text": "Organisez tous les contenus et matériaux que vous avez créés dans des dossiers et retrouvez-les facilement.",
          "title": "Votre espace de stockage",
          "videoId": "1154655532",
          "videoTitle": "Tutoriel : Organiser vos contenus"
        },
        "share": {
          "text": "Partagez et utilisez du matériel avec des collègues. Grâce au remix, ils peuvent le copier, l'adapter et l'utiliser.",
          "title": "Partager, c'est prendre soin : Utiliser le matériel ensemble"
        }
      },
      "labels": {
        "foldersNew": "Créer un dossier"
      },
      "bulk": {
        "actionsDropdown": "Contenus ...",
        "clearSelection": "Désélectionner",
        "modals": {
          "delete": {
            "description": "Les contenus sélectionnés seront déplacés dans la corbeille. Vous pouvez restaurer les contenus de la corbeille dans les 30 jours.",
            "heading": "Déplacer vers la corbeille",
            "singleItemDescription": "Vous pouvez restaurer les contenus de votre corbeille dans les 30 jours.",
            "submit": "Oui, dans la corbeille"
          },
          "move": {
            "heading": "Déplacer les contenus"
          }
        },
        "moveToFolder": "Déplacer dans un dossier",
        "selectedItems": "{count} contenu sélectionné | {count} contenus sélectionnés",
        "undiscardItems": "Restaurer"
      },
      "filter": {
        "customRange": "Définir la période",
        "dateFrom": "De",
        "dateTo": "À",
        "duration": "Période",
        "items": "Matériel et dossiers",
        "last30Days": "30 derniers jours",
        "last7Days": "7 derniers jours",
        "lastYear": "L'année dernière ({ year })",
        "thisYear": "Cette année ({ year })",
        "totalPeriod": "Toute la période"
      },
      "links": {
        "trash": "Vers la corbeille"
      },
      "modals": {
        "createFolder": {
          "heading": "Créer un dossier"
        },
        "moveFolder": {
          "folder": "Dossier",
          "moveToNewFolder": "Déplacer dans un nouveau dossier",
          "newFolder": "Nouveau dossier"
        },
        "renameFolder": {
          "heading": "Renommer le dossier"
        }
      },
      "navbarTitle": "Mon espace de stockage",
      "search": {
        "placeholder": "Rechercher dans mon espace de stockage..."
      },
      "subtitle": "Mon espace de stockage",
      "title": "Mon espace de stockage"
    }
  }
}
